import script from "./SavesManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./SavesManager.vue?vue&type=script&setup=true&lang=ts"

import "./SavesManager.vue?vue&type=style&index=0&id=458d7fce&scoped=true&lang=css"
import "./SavesManager.vue?vue&type=style&index=1&id=458d7fce&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-458d7fce"]])

export default __exports__